export const QueryKeys = {
  TOP_RFPS: ["topRfps"],
  TEMPLATES: ["templates"],
  CREDITS: ["credits"],
  SUBSCRIPTION:             ["subscription"],
  BILLING_OVERVIEW: ["billingOverview"],
  BILLING_HISTORY: (span, from, to, limit) =>
    ["billingHistory", span ?? "", from ?? "", to ?? "", limit ?? 0],
  BILLING_HISTORY_ALL: ["billingHistory"],
  TEMPLATE_DETAIL: (templateId) => ["templates", templateId],
  TEMPLATE_OPPORTUNITIES: (slug) => ["template-opportunities", slug],
  TEMPLATE_OPPORTUNITIES_ALL: ["template-opportunities"],
  OPPORTUNITIES: (search) => ["opportunities", search ?? ""],
  OPPORTUNITIES_ALL: ["opportunities"],
  TODAY_RFPS_ALL: ["todayRfps"],
  GROUP_RFPS: (groupId) => groupId ? ["groupRfps", groupId, "source-v2"] : ["groupRfps"],
  GROUP_RFPS_ALL: ["groupRfps"],
  VOTING_ANALYTICS: (companyId, weeks) =>
    companyId ? ["votingAnalytics", companyId, weeks] : ["votingAnalytics"],

  TODAY_RFPS: (filter, page, pageSize, sortBy, sortOrder) =>
    ["todayRfps", filter, page, pageSize, sortBy, sortOrder],
  RFP_DETAILS: (rfpId, source = "legacy") => ["rfpDetails", source, rfpId],
  EMAIL_PREFERENCES: ["emailPreferences"],
  TEAM_MEMBERS: (companyId) => ["teamMembers", companyId],
  FEEDBACK_PAGE_CONTEXT: (opportunityId, token) => ["feedbackPageContext", opportunityId, token],
  PASS_REASONS: ["passReasons"],
  GROUPS_JOINED:       (search, userId) => ["groupsJoined", search, userId],
  GROUPS_JOINED_ALL:   ["groupsJoined"],
  GROUPS_COMPANY:      (search, userId) => ["groupsCompany", search, userId],
  GROUPS_COMPANY_ALL:  ["groupsCompany"],
  GROUPS_PENDING:      (search, userId) => ["groupsPending", search, userId],
  GROUPS_PENDING_ALL:  ["groupsPending"],
  GROUPS_MY:           (search, userId) => ["groupsMy", search, userId],
  GROUPS_MY_ALL:       ["groupsMy"],
  GROUP_DETAILS:       (groupId) => ["groupDetails", groupId, "source-v2"],
  GROUP_MEMBERS:       (groupId) => ["groupMembers", groupId],
  GROUP_DOCUMENTS:     (groupId) => ["groupDocuments", groupId],
  GROUP_ARCHIVED_RFPS: (groupId) => ["groupArchivedRfps", groupId],
  GROUP_ARCHIVED_RFPS_ALL: ["groupArchivedRfps"],
  GROUP_JOIN_REQUESTS: (groupId) => ["groupJoinRequests", groupId],
  AVAILABLE_USERS:          (groupId, search) => ["availableUsers", groupId, search],
  GROUP_TARGETING_DOCUMENT:  (groupId) => ["groupTargetingDocument", groupId],
  GROUP_PIPELINE_STATS:      (groupId) => ["groupPipelineStats", groupId],
  GROUP_PIPELINE_STATS_ALL:  ["groupPipelineStats"],
  TARGETING_DOCUMENT_CHAT:   (groupId) => ["targetingDocumentChat", groupId],
  TARGETING_DOCUMENT_VERSIONS: (groupId) => ["targetingDocumentVersions", groupId],
  TARGETING_DOCUMENT_RULES:  (groupId) => ["targetingDocumentRules", groupId],
  MATCHED_GROUPS:            (opportunityId) => ["matchedGroups", opportunityId],
  GROUP_VOTE_FEEDBACK: (groupId) => groupId ? ["groupVoteFeedback", groupId] : ["groupVoteFeedback"],
  MATCH_ANALYSIS:       (groupId, oppId) => ["matchAnalysis", groupId, oppId],
  EXTERNAL_PARTNERS:    ["externalPartners"],
  EXTERNAL_PENDING:     ["externalPendingInvites"],
  EXTERNAL_INCOMING:    ["externalIncomingInvites"],
  CONNECTION_GROUPS:    (id) => ["connectionGroups", id],
};
